import React from 'react';
import { Typography } from '@components/atoms/typography';
import type { CardProps } from '@modules/dashboard/pages/docs-verification/docs-verification-page/docs-verification-steps/start/card/types';

import { CardContainer } from './styles';

export const Card: React.FC<CardProps> = ({ icon, number, description }) => (
    <CardContainer>
        <div className='card__icon'>
            <img src={icon} alt='icon' />
        </div>
        <div className='card__number'>{number}</div>
        <Typography tag='div' variant='text-bold' className='card__description'>
            {description}
        </Typography>
    </CardContainer>
);
